module.exports = __webpack_public_path__ + "static/media/runner_executives.3879a785.svg";